module.exports = __webpack_public_path__ + "img/Check.75accc6b.gif";